import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private jwthelper: JwtHelperService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (next.routeConfig?.path === '/auth/login') {
      return this.jwthelper.tokenGetter() !== null && !this.jwthelper.isTokenExpired() ? this.router.navigate(['/dashboard']) : true;
    }
    return this.jwthelper.tokenGetter() !== null && !this.jwthelper.isTokenExpired() ? true : this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
  }
}
